__turbopack_context__.v({
  "award": "CardFoodServiceProduct-module-scss-module__ka9aqq__award",
  "card": "CardFoodServiceProduct-module-scss-module__ka9aqq__card",
  "cardContent": "CardFoodServiceProduct-module-scss-module__ka9aqq__cardContent",
  "cardInner": "CardFoodServiceProduct-module-scss-module__ka9aqq__cardInner",
  "cardInner--dark-text": "CardFoodServiceProduct-module-scss-module__ka9aqq__cardInner--dark-text",
  "cardLinkWrap": "CardFoodServiceProduct-module-scss-module__ka9aqq__cardLinkWrap",
  "cta": "CardFoodServiceProduct-module-scss-module__ka9aqq__cta",
  "eyebrow": "CardFoodServiceProduct-module-scss-module__ka9aqq__eyebrow",
  "fade-in": "CardFoodServiceProduct-module-scss-module__ka9aqq__fade-in",
  "featured": "CardFoodServiceProduct-module-scss-module__ka9aqq__featured",
  "icon": "CardFoodServiceProduct-module-scss-module__ka9aqq__icon",
  "image": "CardFoodServiceProduct-module-scss-module__ka9aqq__image",
  "imageContainer": "CardFoodServiceProduct-module-scss-module__ka9aqq__imageContainer",
  "imageContainer--portrait": "CardFoodServiceProduct-module-scss-module__ka9aqq__imageContainer--portrait",
  "isVisible": "CardFoodServiceProduct-module-scss-module__ka9aqq__isVisible",
  "textGroup": "CardFoodServiceProduct-module-scss-module__ka9aqq__textGroup",
  "theme--makers-reserve": "CardFoodServiceProduct-module-scss-module__ka9aqq__theme--makers-reserve",
  "topSeller": "CardFoodServiceProduct-module-scss-module__ka9aqq__topSeller",
});
